<template>
  <v-container fluid style="max-width: 1440px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Modal Escaner código de barra -->
        <v-dialog v-model="dialogCamara" max-width="400" persistent>
          <v-card>
            <v-toolbar dense flat color="primary" dark>
              <v-toolbar-title>Escanear Código</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="detenerEscaneo"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pa-2">
              <video ref="video" autoplay muted playsinline
                style="width: 100%; height: auto; object-fit: cover; border-radius: 8px;" />
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal escaner código de barra -->

        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false" right>{{
          alerta.text
          }}</v-snackbar>

        <!-- Listado de bienes y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="cabBienes" :items="bienes" :items-per-page="15" disable-pagination
          hide-default-footer class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">BAJA DE BIENES</v-toolbar-title>
              <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
              <v-spacer />
              <!-- Formulario busqueda de bien -->
              <v-text-field class="text-xs-center" v-model.trim="buscar" @keyup="listar()" maxlength="40"
                append-icon="search" v-uppercase dense label="Búsqueda" hide-details></v-text-field>
              <v-spacer />

              <!-- <v-text-field dense autofocus class="text-xs-center mr-2" v-model.trim="codigo_barra"
                append-icon="qr_code_2" label="Código de Barra" @keyup.enter="buscarCodigoBarra()"
                :rules="[v => !!v || 'requerido', v => (!!v && v.length >= 12 && v.length < 13) || 'requerido']"
                maxlength="12" hide-details v-mask-number clearable></v-text-field> -->

              <v-text-field dense autofocus class="mr-2" v-model.trim="codigo_barra" prepend-icon="barcode_reader"
                @click:prepend="iniciarEscaneo" label="Código de Barra" @keyup.enter="buscarCodigoBarra()"
                :rules="[v => !!v || 'requerido', v => (!!v && v.length >= 8) || 'requerido']" maxlength="15"
                hide-details clearable></v-text-field>

              <!-- <v-btn
              x-small
              fab
              color="info"
              @click="buscarCodigoBarra()"
              class="hidden-sm-and-down"
            >
              <v-icon>search</v-icon>
              </v-btn>-->
              <!-- Fin Formulario Busqueda de bien -->
              <v-spacer />
              <!-- Modal crear y modificar bien -->
              <v-dialog v-model="dialog" max-width="1000px" persistent>
                <v-card>
                  <v-toolbar dark dense class="warning">
                    <v-toolbar-title>Modificar Baja de Bien</v-toolbar-title>
                    <v-spacer />
                    <strong>{{ codbien }}</strong>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-container>
                        <v-toolbar-title class="mb-3 primary--text">
                          Datos del Bien
                          <v-list-item-subtitle v-if="codtipobien != null && codtipobien != ''" class="info--text">Grupo
                            Genérico: {{ grupo }} Clase: {{ clase }}</v-list-item-subtitle>
                        </v-toolbar-title>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-autocomplete dense @keyup="selectTbien()" :search-input.sync="buscar_tipobien"
                              v-model.trim="codtipobien" :items="selectTipobienArray" label="Selecciona Tipo Bien"
                              :rules="[v => !!v || 'Requerido']" :disabled="disabledcodtipobien"
                              @change="mostrarGrupoClase()" clearable hide-details></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete dense @keyup="selectAsignacion()" :search-input.sync="buscar_personal"
                              v-model.trim="idasignacion" :items="selectAsignacionArray"
                              label="Selecciona: Personal | Local > Area" :rules="[v => !!v || 'Requerido']" clearable
                              hide-details></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.tipo_ctas" v-model="tipo_cta" label="Tipo de Cuenta"
                              :rules="[v => !!v || 'Requerido']" @change="selectCuentascArray = [], selectCcontable()"
                              required hide-details></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select dense v-model.trim="cuenta" :items="selectCuentascArray"
                              label="Selecciona Cuenta Contable" :rules="[v => !!v || 'Requerido']"
                              :disabled="tipo_cta == '' ? true : false" hide-details></v-select>
                          </v-col>
                          <v-col cols="6" sm="3">
                            <v-select dense :items="cm.flg_conds" v-model="flg_cond" label="Forma de Adq."
                              :rules="[v => !!v || 'Requerido']" required disabled hide-details></v-select>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-menu v-model="menuFechaRegistro" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field dense v-model="fecha_registro_formateado" label="Fecha Adq."
                                  :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" disabled
                                  hide-details></v-text-field>
                              </template>
                              <v-date-picker v-model="fec_reg" @input="menuFechaRegistro = false"
                                @change="fechaRegistroSeleccionada(fec_reg)"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-text-field dense v-model.trim="doc_alta" label="Doc. Adq." maxlength="25" disabled
                              v-uppercase hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-mask-decimal.us="2" v-model.trim="valordq" label="Valor Adq."
                              maxlength="13" v-uppercase hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-mask-decimal.us="2" v-model.trim="valorlibro" label="Valor Neto"
                              maxlength="13" v-uppercase hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-select dense :items="cm.flg_estados" v-model="flg_estado" label="Estado del Bien"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.flg_asegurados" v-model="asegurado" label="Asegurado"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.flg_situaciones" v-model="situacion" label="Situación"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-container>
                        <v-toolbar-title class="mb-3 warning--text">Acto de Baja</v-toolbar-title>
                        <v-row>
                          <v-col cols="6" sm="3">
                            <v-text-field dense v-model.trim="resol_baja" label="Resolución Baja" maxlength="25"
                              v-uppercase hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-menu v-model="menuFechaBaja" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field dense v-model="fecha_baja_formateado" label="Fecha"
                                  :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on"
                                  hide-details></v-text-field>
                              </template>
                              <v-date-picker v-model="fec_baja" @input="menuFechaBaja = false"
                                @change="fechaBajaSeleccionada(fec_baja)"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6" sm="3">
                            <v-select dense :items="cm.flg_causales" v-model="flg_causal" label="Causal de Baja"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-container>
                        <v-toolbar-title class="mb-3 primary--text">Detalle Técnico</v-toolbar-title>
                        <v-row>
                          <v-col cols="6" sm="3">
                            <v-text-field dense v-model.trim="marca" label="Marca" maxlength="100" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3">
                            <v-text-field dense v-model.trim="modelo" label="Modelo" maxlength="50" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="tipo" label="Tipo" maxlength="50" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="color" label="Color" maxlength="15" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="serie" label="Serie" maxlength="25" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="dimension" label="Dimensión m*a*h" maxlength="25"
                              v-uppercase hide-details></v-text-field>
                          </v-col>
                          <!-- NO VISUALIZAMOS SI PERTENENCE A LA CLASE 82=vehiculos,04=aeronaves,36=Maquinaria pesada -->
                          <template
                            v-if="codtipobien == null ? false : (codtipobien.substring(2, 4) == '82') ? true : (codtipobien.substring(2, 4) == '04') ? true : (codtipobien.substring(2, 4) == '36')">
                            <v-col cols="6" sm="2">
                              <v-text-field dense v-model.trim="placa" label="Placa" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="2">
                              <v-text-field dense v-model.trim="ano" label="Año" maxlength="4" v-mask-number
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="nummotor" label="Nº Motor" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="numchasis" label="Nº Chasis" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>

                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="carroceria" label="Carroceria" maxlength="30"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="nro_ejes" label="Nº Ejes" maxlength="10" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="combustible" label="Combustible" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="transmision" label="Transmisión" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="cilindrada" label="Cilindrada" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="kilometraje" label="Kilometraje" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="tarjeta_propiedad" label="Tarjeta Propiedad"
                                maxlength="30" v-uppercase hide-details></v-text-field>
                            </v-col>
                          </template>
                          <v-col cols="12">
                            <v-textarea dense rows="1" v-model.trim="otras_caract" label="Otras Caracteristicas"
                              maxlength="254" v-uppercase hide-details></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="2" v-model.trim="observacion" label="Observación" maxlength="254"
                              v-uppercase hide-details></v-textarea>
                          </v-col>

                          <!-- Imagen -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen == '' || imagen == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template color="teal" v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen($event)" class="d-none" />
                          </v-col>

                          <!-- Imagen 2 -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen2 == '' || imagen2 == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton2.click()" />
                              </v-avatar>
                            </template>
                            <template v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen2" @click="$refs.boton2.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file2" ref="boton2" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen2($event)" class="d-none" />
                          </v-col>

                          <!-- Imagen 3 -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen3 == '' || imagen3 == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton3.click()" />
                              </v-avatar>
                            </template>
                            <template v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen3" @click="$refs.boton3.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file3" ref="boton3" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen3($event)" class="d-none" />
                          </v-col>

                          <!-- Mensaje error bien -->
                          <v-col cols="12" v-if="mensajeBien != ''">
                            <v-alert text dense type="error">{{ mensajeBien }}</v-alert>
                          </v-col>
                          <!-- Mensaje error bien -->
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar bien -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar bien -->
          <template v-slot:item.codbien="{ item }">
            <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
          </template>

          <template v-slot:item.tbdescripcion="{ item }">
            <div class="text-caption">
              <strong>{{ item.tbdescripcion }}</strong>
            </div>
          </template>

          <template v-slot:item.ubicacion="{ item }">
            <div class="text-caption">
              <v-icon x-small color="info">location_city</v-icon>
              {{ item.nomlocales }}
            </div>
            <div class="ml-1 text-caption">
              <v-icon x-small color="info">hub</v-icon>
              {{ item.nomareas }}
            </div>
            <div class="ml-2 text-caption">
              <v-icon x-small color="info">meeting_room</v-icon>
              <strong> {{ item.nomoficinas }}</strong>
            </div>
            <div class="ml-3 text-caption">
              <v-icon x-small color="internal">face</v-icon>
              <strong> {{ item.pnombres }}</strong>
            </div>
          </template>

          <!-- est_bien -->
          <template v-slot:item.est_bien="{ item }">
            <template>
              <v-btn text x-small color="warning" @click="activarMostrar(1, item)">Restituir</v-btn>
            </template>
          </template>
          <!-- Fin est_bien -->

          <template v-slot:item.actividad="{ item }">
            <div class="text-caption">
              <v-icon x-small color="internal">person</v-icon>
              {{ item.nickname }}
            </div>
            <div class="text-caption">
              <v-icon x-small color="primary">schedule</v-icon>
              {{ item.fec_act | formatearFechaHora }}
            </div>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small icon v-bind="attrs" v-on="on">
                  <v-icon color="accent" @click="mostrarBienImp(item)">description</v-icon>
                </v-btn>
              </template>
              <span>Ficha Bien Patrimonial</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small icon v-bind="attrs" v-on="on">
                  <v-icon color="info" @click="editBajaBienItem(item)">edit</v-icon>
                </v-btn>
              </template>
              <span>Modificar Bien</span>
            </v-tooltip>
          </template>
          <!-- Fin Opciones editar, eliminar bien -->
        </v-data-table>
        <!-- Modal activarbien -->
        <v-dialog v-model="adModal" max-width="400">
          <v-card>
            <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Restituir Alta?</v-card-title>
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">restituir alta</span>
              del bien: {{ adId }}
            </v-card-text>
            <v-card-actions class="py-0 pb-4 justify-center">
              <v-btn text x-small color="error" @click="activarDesactivarCerrar()">Cancelar</v-btn>
              <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar()">Restituir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Fin Modal activar bien -->
        <!-- Fin Listado de bienes y opciones de titulo, busqueda, nuevo, etc -->

        <!-- Mostrar impresion Modal bien -->
        <v-dialog v-model="verBienModal" max-width="980px" scrollable>
          <v-card>
            <v-toolbar dark dense class="primary">
              <v-toolbar-title>Baja de Bien Patrimonial</v-toolbar-title>
              <v-spacer />
              <span>{{ codbien }}</span>
              <v-spacer />
              <v-btn icon dark class="hidden-sm-and-down" @click="printExternal()">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn icon dark @click="savePdf()">
                <v-icon>download</v-icon>
              </v-btn>
              <v-btn icon dark @click="ocultarBienImp()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 520px;" class="px-0">
              <pdf :src="stringPdf"></pdf>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar impresion Modal bien -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import moment from "moment"; // Formatear Fechas
import numeral from "numeral"; // Formater numeros
import pdf from "vue-pdf"; // Visor de pdf
import { BrowserMultiFormatReader } from '@zxing/library';
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      bienes: [],
      dialog: false,
      cabBienes: [
        { text: "OPC.", value: "opciones", sortable: false, width: 90 },
        { text: "C. Patrimonial", value: "codbien", sortable: false, width: 135 },
        { text: "Tipo Bien", value: "tbdescripcion", sortable: false },
        { text: "Ubicación", value: "ubicacion", sortable: false },
        { text: "Modificado por", value: "actividad", sortable: false },
        { text: "Restituir", value: "est_bien", sortable: false },
      ],

      // Escaner barra
      dialogCamara: false,
      lector: null,
      escaneando: false,

      codigo_barra: "",
      // Frm bien
      idbien: "",
      codbien: "",
      codlocal: "", // selectLocalArray
      codtipobien: "", // selectTipobienArray
      correlativo: "",
      codarea: "", // selectAreaArray
      idasignacion: "", // selectAsignacionArray
      imagen: "",
      imagen2: "",
      imagen3: "",
      marca: "",
      modelo: "",
      tipo: "",
      color: "",
      serie: "",
      dimension: "",
      nummotor: "",
      numchasis: "",
      placa: "",
      ano: "",

      carroceria: "",
      nro_ejes: "",
      combustible: "",
      transmision: "",
      cilindrada: "",
      kilometraje: "",
      tarjeta_propiedad: "",

      asegurado: "",
      otras_caract: "",
      fec_reg: "",
      doc_alta: "",
      tipo_cta: "", // tipo_ctas
      cuenta: "", // selectCuentascArray
      valordq: "",
      valorlibro: "",
      flg_cond: "", // flg_conds
      flg_estado: "", // flg_estados
      situacion: "",

      flg_causal: "",
      resol_baja: "",
      fec_baja: "",

      idusuario: "",
      observacion: "",
      // Fin Frm bien
      buscar: "",

      grupo: "",
      clase: "",

      mensajeBien: "",

      // Select
      selectCuentascArray: [],

      selectTipobienArray: [],
      buscar_tipobien: "",

      selectAsignacionArray: [],
      buscar_personal: "",

      fecha_registro_formateado: "",
      menuFechaRegistro: false,

      fecha_baja_formateado: "", // baja
      menuFechaBaja: false,

      disabledcodtipobien: false,

      stringPdf: "",
      blobPdf: "",
      verBienModal: 0,
      // Fin Select

      desabilitar: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      adModal: 0,
      adAccion: 0,
      adId: "",

      imagenxdefec: "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",

      file: null,
      file2: null,
      file3: null,
      urlTemporal: "",
      urlTemporal2: "",
      urlTemporal3: "",
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]),
    ...mapGetters(["esSuperadministrador", "esAdministrador"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    //#region CAPTURA
    iniciarEscaneo() {
      this.codigo_barra = ""
      this.lector = new BrowserMultiFormatReader()
      this.escaneando = true
      this.dialogCamara = true

      this.$nextTick(() => {
        // Espera a que el DOM se actualice (video disponible)
        this.lector.decodeFromConstraints(
          {
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            }
          },
          this.$refs.video,
          (result, err) => {
            if (result && this.escaneando) {
              this.codigo_barra = result.getText()
              this.detenerEscaneo()
              this.buscarCodigoBarra()
            }
          }
        )
        /* this.lector.decodeFromVideoDevice(null, this.$refs.video, (result, err) => {
          if (result && this.escaneando) {
            this.codigo_barra = result.getText()
            this.detenerEscaneo()
            this.buscarCodigoBarra()
          }
        }) */
      })
    },

    detenerEscaneo() {
      if (this.lector) {
        this.lector.reset()
        this.escaneando = false
        this.dialogCamara = false;
      }
    },
    //#endregion CAPTURA

    // Para descargar pdf de blob
    savePdf() {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(this.blobPdf);
      var fileName = "Ficha baja de bienes " + this.codbien;
      link.download = fileName;
      link.click();
    },

    // Llamamos de main.js printJS
    printExternal() {
      printJS({
        printable: this.stringPdf.replace(
          "data:application/pdf;filename=generated.pdf;base64,",
          ""
        ),
        type: "pdf",
        base64: true,
      });
    },

    /* Listar bienes */
    listar() {
      let me = this;
      me.loading = true;

      axios
        .get("api/Bienes/ListarBajaBienEmpresaFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            buscar: me.buscar,
          },
        })

        .then(function (response) {
          me.bienes = response.data;
          me.loading = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },

    buscarCodigoBarra() {
      let me = this;
      me.loading = true;
      if (me.codigo_barra.length < 12) {
        me.loading = false;
        me.alerta.snackbar = true;
        me.alerta.color = "info";
        return (me.alerta.text = "El Código de barra no es valido.");
      }

      axios
        .get("api/Bienes/BuscarCodigoBarraBajaBien/" + me.codigo_barra + "/" + me.usuarioState.idempresa)
        .then(function (response) {
          var data = [response.data];
          me.bienes = data;
          //console.log(data);
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = "El código de bien '" + me.codigo_barra + "'. Existe en la base de datos.";
          me.loading = false;
          me.loading = false;
          //me.codigo_barra = "";
        })
        .catch(function (error) {
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "El Código de bien '" + me.codigo_barra + "'. No existe en la base de datos.";
          me.loading = false;
          //console.log(error);
        });
    },
    /* Fin Listar bienes */

    // Seleccionar Cuenta y tipobien por busqueda
    selectCcontable(id) {
      let me = this;
      var cuentacArray = [];

      let url = "";
      if (id) {
        url = "api/Cuentasc/SelectCuentac?buscar=" + (id == "" ? "-" : id);
      } else {
        if (me.usuarioState.tipoempresa == "ESTATAL") {
          url = "api/Cuentasc/SelectCuentascEstatal?tipo_cta=" + me.tipo_cta;
        } else {
          url = "api/Cuentasc/SelectCuentascPrivado?tipo_cta=" + me.tipo_cta;
        }
      }
      axios
        .get(url)
        .then(function (response) {
          cuentacArray = response.data;
          cuentacArray.map(function (x) {
            me.selectCuentascArray.push({
              text: x.cuenta + " " + x.denominacion,
              value: x.cuenta,
            });
          });
        })
        .catch(function (error) {
          //console.log(url);
        });
    },

    mostrarGrupoClase() {
      let me = this;
      if (me.codtipobien != null || "") {
        axios
          .get("api/Grupos/Mostrar", {
            params: {
              idgrupo:
                me.codtipobien == null ? "" : me.codtipobien.substring(0, 2),
            },
          })
          .then(function (response) {
            var data = [response.data];
            me.grupo = data[0].dscgrupo;
          })
          .catch(function (error) { });

        axios
          .get("api/Clases/Mostrar", {
            params: {
              idclase:
                me.codtipobien == null ? "" : me.codtipobien.substring(2, 4),
            },
          })
          .then(function (response) {
            var data = [response.data];
            me.clase = data[0].dscclase;
          })
          .catch(function (error) { });
      }
    },

    selectTbien(id) {
      let me = this;
      var bienArray = [];

      let url = "";
      if (id) {
        url = "api/Tipobienes/SelectTipoBien?buscar=" + (id == "" ? "-" : id);
      } else {
        url = "api/Tipobienes/SelectTipoBienesFiltro?buscar=" + (me.buscar_tipobien == "" ? "-" : me.buscar_tipobien == null ? "-" : me.buscar_tipobien);
      }
      axios
        .get(url)
        .then(function (response) {
          bienArray = response.data;
          bienArray.map(function (x) {
            me.selectTipobienArray.push({
              text: x.codtipobien + " " + x.descripcion,
              value: x.codtipobien,
            });
          });
        })
        .catch(function (error) {
          //console.log(url);
        });
    },

    selectAsignacion(id) {
      let me = this;
      var asignacionArray = [];

      if (id) {
        // Select idasignacion
        axios
          .get(
            "api/Asignaciones/SelectAsignacion?idasignacion=" +
            (id == "" ? "-" : id)
          )

          .then(function (response) {
            asignacionArray = response.data;
            asignacionArray.map(function (x) {
              me.selectAsignacionArray.push({
                text: x.nompersonal + " | " + x.nomlocal.substring(0, 20) + " > " + x.nomarea.substring(0, 20),
                value: x.idasignacion,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        // Select personal para area de la empresa
        axios
          .get("api/Asignaciones/SelectAsignacionFiltro", {
            params: {
              idempresa: me.usuarioState.idempresa,
              buscar: me.buscar_personal == "" ? "-" : me.buscar_personal == null ? "-" : me.buscar_personal,
            },
          })

          .then(function (response) {
            asignacionArray = response.data;
            asignacionArray.map(function (x) {
              me.selectAsignacionArray.push({
                text: x.nompersonal + " | " + x.nomlocal.substring(0, 20) + " > " + x.nomarea.substring(0, 20),
                value: x.idasignacion,
              });
            });
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },

    // Fin Seleccionar Cuenta y tipobien por busqueda

    /* Registrar baja bien */
    guardar() {
      let me = this;
      me.desabilitar = true;

      //Código para guardar
      axios
        .put("api/bienes/BajaBien", {
          idbien: me.idbien,
          codbien: me.codbien,
          idempresa: me.idempresa,
          idasignacion: me.idasignacion,
          imagen: me.imagen,
          imagen2: me.imagen2,
          imagen3: me.imagen3,
          marca: me.marca,
          modelo: me.modelo,
          tipo: me.tipo,
          color: me.color,
          serie: me.serie,
          dimension: me.dimension,
          nummotor: me.nummotor,
          numchasis: me.numchasis,
          placa: me.placa,
          ano: me.ano,

          carroceria: me.carroceria,
          nro_ejes: me.nro_ejes,
          combustible: me.combustible,
          transmision: me.transmision,
          cilindrada: me.cilindrada,
          kilometraje: me.kilometraje,
          tarjeta_propiedad: me.tarjeta_propiedad,

          asegurado: me.asegurado,
          otras_caract: me.otras_caract,
          fec_reg: me.fec_reg,
          doc_alta: me.doc_alta,
          tipo_cta: me.tipo_cta, // tipo_ctas
          cuenta: me.cuenta, // selectCuentascArray
          valordq: me.valordq == "" ? 0 : me.cm.removeComa(me.valordq),
          valorlibro:
            me.valorlibro == "" ? 0 : me.cm.removeComa(me.valorlibro),
          flg_cond: me.flg_cond, // flg_conds
          flg_estado: me.flg_estado, // flg_estados

          flg_causal: me.flg_causal, // flg_causal
          resol_baja: me.resol_baja,
          fec_baja: me.fec_baja,

          idusuario: parseInt(me.usuarioState.idusuario),
          observacion: me.observacion,
          situacion: me.situacion,
        })
        .then(function (response) {
          me.desabilitar = false;
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = response.data;
          me.close();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.desabilitar = false;
          me.mensajeBien = error.response.data;
          me.limpiarAlertaError();
        });
    },
    /* Fin Registrar baja bien */

    /* Buscar imagen bien */
    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    buscarImagen2(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal2 = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ? atob(dataURI.split(",")[1]) : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen2 = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    buscarImagen3(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal3 = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ? atob(dataURI.split(",")[1]) : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen3 = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    /* Fin Buscar imagen bien */

    /* Formatear fecha registro */
    fechaRegistroSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_registro_formateado = ddmmyy;
    },

    fechaBajaSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_baja_formateado = ddmmyy;
    },
    /* Fin Formatear fecha registro */

    /* Limpiar mensaje bien */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeBien = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje bien */

    /* Editar bien item */
    editBajaBienItem(item) {
      this.idbien = item.idbien;
      this.codbien = item.codbien;
      this.codtipobien = item.codtipobien; // selectTbien
      this.selectTbien(item.codtipobien);
      this.correlativo = item.correlativo;
      this.idempresa = item.idempresa;
      this.idasignacion = item.idasignacion;
      this.selectAsignacion(item.idasignacion);
      this.imagen = item.imagen;
      this.imagen2 = item.imagen2;
      this.imagen3 = item.imagen3;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.tipo = item.tipo;
      this.color = item.color;
      this.serie = item.serie;
      this.dimension = item.dimension;
      this.nummotor = item.nummotor;
      this.numchasis = item.numchasis;
      this.placa = item.placa;
      this.ano = item.ano;

      this.carroceria = item.carroceria;
      this.nro_ejes = item.nro_ejes;
      this.combustible = item.combustible;
      this.transmision = item.transmision;
      this.cilindrada = item.cilindrada;
      this.kilometraje = item.kilometraje;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.asegurado = item.asegurado;
      this.otras_caract = item.otras_caract;
      this.fec_reg = item.fec_reg;
      this.fechaRegistroSeleccionada(item.fec_reg);
      this.doc_alta = item.doc_alta;
      this.tipo_cta = item.tipo_cta;
      this.cuenta = item.cuenta; // selectCcontable
      this.selectCcontable(item.cuenta);
      this.valordq = parseFloat(item.valordq).toFixed(2);
      this.valorlibro = parseFloat(item.valorlibro).toFixed(2);
      this.flg_cond = item.flg_cond;
      this.flg_estado = item.flg_estado;
      this.flg_causal = item.flg_causal;
      this.resol_baja = item.resol_baja;
      this.fec_baja = item.fec_baja;
      this.fechaBajaSeleccionada(item.fec_baja);
      this.idusuario = item.idusuario;
      this.observacion = item.observacion;
      this.situacion = item.situacion;
      this.mostrarGrupoClase();

      this.disabledcodtipobien = true; //para tipo bien
      this.dialog = true;
    },
    /* Fin Editar bien item */

    /* Mostrar bien item */
    ocultarBienImp() {
      this.verBienModal = 0;
      this.limpiar();
    },

    mostrarBienImp(item) {
      this.codbien = item.codbien;
      this.locales = item.locales;
      this.codtipobien = item.codtipobien; // selectTbien
      this.correlativo = item.correlativo;
      this.codlocal = item.codlocal; // selectLocal
      this.areas = item.areas;
      this.codarea = item.codarea;
      this.codempleado = item.codempleado;
      this.empleadodna = item.empleadodna;
      this.imagen = item.imagen;
      this.imagen2 = item.imagen2;
      this.imagen3 = item.imagen3;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.tipo = item.tipo;
      this.color = item.color;
      this.serie = item.serie;
      this.dimension = item.dimension;
      this.nummotor = item.nummotor;
      this.numchasis = item.numchasis;
      this.placa = item.placa;
      this.matricula = item.matricula;
      this.ano = item.ano;

      this.carroceria = item.carroceria;
      this.nro_ejes = item.nro_ejes;
      this.combustible = item.combustible;
      this.transmision = item.transmision;
      this.cilindrada = item.cilindrada;
      this.kilometraje = item.kilometraje;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.asegurado = item.asegurado;
      this.otras_caract = item.otras_caract;
      this.fec_reg = item.fec_reg;
      this.doc_alta = item.doc_alta;
      this.tipo_cta = item.tipo_cta;
      this.cuenta = item.cuenta; // selectCcontable
      this.valordq = item.valordq;
      this.valorlibro = item.valorlibro;
      this.flg_cond = item.flg_cond;
      this.flg_estado = item.flg_estado;
      this.flg_causal = item.flg_causal;
      this.resol_baja = item.resol_baja;
      this.fec_baja = item.fec_baja;
      this.observacion = item.observacion;
      this.situacion = item.situacion;

      this.tbdescripcion = item.tbdescripcion;
      this.nomlocales = item.nomlocales;
      this.nomareas = item.nomareas;
      this.pnombres = item.pnombres;
      this.pnrodoc = item.pnrodoc;

      this.verBienModal = 1;
      this.crearPDF();
    },
    /* Fin Mostrar bien item */

    /* Cerrar ventana bien */
    close() {
      this.dialog = false;
      this.limpiar();
    },
    /* Fin Cerrar ventana bien */

    /* Limpiar bien item */
    limpiar() {
      this.idbien = "";
      this.codbien = "";
      this.codtipobien = ""; // selectTipobienArray
      this.correlativo = "";
      this.idempresa = "";
      this.idasignacion = "";
      this.imagen = "";
      this.imagen2 = "";
      this.imagen3 = "";
      this.marca = "";
      this.modelo = "";
      this.tipo = "";
      this.color = "";
      this.serie = "";
      this.dimension = "";
      this.nummotor = "";
      this.numchasis = "";
      this.placa = "";
      this.ano = "";

      this.carroceria = "";
      this.nro_ejes = "";
      this.combustible = "";
      this.transmision = "";
      this.cilindrada = "";
      this.kilometraje = "";
      this.tarjeta_propiedad = "";

      this.asegurado = "";
      this.otras_caract = "";
      this.fec_reg = "";
      this.fecha_registro_formateado = "";
      this.doc_alta = "";
      this.tipo_cta = ""; // tipo_ctas
      this.cuenta = ""; // selectCuentascArray
      this.valordq = "";
      this.valorlibro = "";
      this.flg_cond = ""; // flg_conds
      this.flg_estado = ""; // flg_estados
      this.idusuario = "";
      this.observacion = "";
      this.situacion = "";

      this.selectTipobienArray = [];
      this.selectAsignacionArray = [];
      this.selectCuentascArray = [];

      this.selectLocalArray = [];
      this.selectAreaArray = [];

      this.disabledcodtipobien = false;

      this.tbdescripcion = "";
      this.nomlocales = "";
      this.nomareas = "";
      this.pnombres = "";
      this.pnrodoc = "";

      this.grupo = "";
      this.clase = "";

      this.mensajeBien = "";

      this.file = null;
      this.file2 = null;
      this.file3 = null;
      this.urlTemporal = "";
      this.urlTemporal2 = "";
      this.urlTemporal3 = "";
    },
    /* Fin Limpiar bien item */

    /* Activar baja bien */
    activarMostrar(accion, item) {
      this.adModal = 1;
      this.adId = item.codbien;
      this.idbien = item.idbien;
      if (accion == 1) {
        this.adAccion = 1;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      let me = this;
      axios
        .put("api/Bienes/ActivarBajaBien/" + this.idbien, {})
        .then(function (response) {
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = response.data;
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Activar baja bien */

    /* Crear PDF bien */
    crearPDF() {
      let me = this;

      var doc = new jsPDF("p", "mm", [210, 297]);
      // Titulo
      // Logotipo jala de la empresa a la que se accedio
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      doc.addImage(imgData, "JPEG", 20, 9, 13, 16); // Logo

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text("FICHA DE DATOS - BIENES ACTIVOS", doc.internal.pageSize.width / 2, 18, { align: "center" });
      // Fin Titulo

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(20, 30, "EMPRESA: " + me.empresaState.nombre);

      // Descripcion y codigo bien
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(20, 40, "DENOMINACIÓN");
      doc.setFont("helvetica", "bold");
      doc.roundedRect(20, 42, 140, 4, 1, 1);
      doc.text(23, 45, me.tbdescripcion);
      doc.setFont("helvetica", "normal");
      doc.text(171, 40, "CODIGO BIEN");
      doc.setFont("helvetica", "bold");
      doc.roundedRect(170, 42, 22, 4, 1, 1);
      doc.text(172, 45, me.codbien.length == 12 ? me.codbien : me.codbienint + "-" + me.codinterno);
      // Fin  Descripcion y codigo bien

      // Detalle de Bien

      doc.roundedRect(20, 50, 172, 175, 1, 1);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 55, "UBICACIÓN");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 60, "LOCAL: " + me.nomlocales);
      doc.text(25, 65, "AREA: " + me.nomareas);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 70, "PERSONAL");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 75, "NOMBRE: " + me.pnombres);
      doc.text(150, 75, "DNI: " + me.pnrodoc);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 80, "DATOS GENERALES");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 85, "CUENTA: " + me.cuenta);
      doc.text(100, 85, "VALOR: " + numeral(me.valordq).format("###,##0.00"));

      // Estado
      var estado = "";
      for (var i = 0; i < me.cm.flg_estados.length; i++) {
        estado = estado + (me.cm.flg_estados[i].value == me.cm.flg_estado ? me.cm.flg_estados[i].text : "");
      }
      doc.text(150, 85, "ESTADO: " + estado);
      // Fin Estado

      // Condicion
      var cond = "";
      for (var i = 0; i < me.cm.flg_conds.length; i++) {
        cond = cond + (me.cm.flg_conds[i].value == me.flg_cond ? me.cm.flg_conds[i].text : "");
      }
      doc.text(25, 90, "FORMA ADQUISICIÓN: " + cond);
      // Fin Condicion

      doc.text(100, 90, "FECHA ADQUISICIÓN: " + moment(me.fec_reg).format("DD/MM/YYYY"));
      doc.text(150, 90, "SITUACIÓN: " + (me.situacion == "U" ? "USO" : me.situacion == "D" ? "DESUSO" : "FALTANTE"));
      doc.text(25, 95, "DOCUMENTO ADQ.: " + me.doc_alta);
      doc.text(150, 95, "ASEGURADO: " + (me.asegurado == "S" ? "SI" : "NO"));

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 100, "DETALLE TECNICO");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      let valText = 105;

      doc.text(25, valText, "MARCA: " + me.marca);
      doc.text(70, valText, "MODELO: " + me.modelo);
      doc.text(110, valText, "TIPO: " + me.tipo);
      doc.text(155, valText, "COLOR: " + me.color);

      valText = valText + 5;

      doc.text(25, valText, "SERIE: " + me.serie);
      doc.text(70, valText, "DIMENSIÓN: " + me.dimension);
      //  NO VISUALIZAMOS SI ES 82,04,36
      if (me.codtipobien == null ? false : me.codtipobien.substring(2, 4) == "82" ? true : me.codtipobien.substring(2, 4) == "04" ? true : me.codtipobien.substring(2, 4) == "36") {
        doc.text(110, valText, "PLACA: " + me.placa);
        doc.text(155, valText, "AÑO: " + me.ano);
        valText = valText + 5;
        doc.text(25, valText, "Nº MOTOR: " + me.nummotor);
        doc.text(70, valText, "Nº CHASIS: " + me.numchasis);
        doc.text(130, valText, "CARROCERIA: " + me.carroceria);
        valText = valText + 5;
        doc.text(25, valText, "NRO. EJES: " + me.nro_ejes);
        doc.text(70, valText, "COMBUSTIBLE: " + me.combustible);
        doc.text(130, valText, "TRANSMISIÓN: " + me.transmision);
        valText = valText + 5;
        doc.text(25, valText, "CILINDRADA: " + me.cilindrada);
        doc.text(70, valText, "KILOMETRAJE: " + me.kilometraje);
        doc.text(130, valText, "TARJ. PROPIEDAD: " + me.tarjeta_propiedad);
      }

      doc.autoTable({
        theme: "plain",
        margin: { left: 24, right: 24, top: valText = valText + 3 },
        bodyStyles: {
          cellPadding: 1,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 7,
        },
        body: [
          [{ content: "OTRAS CARACTERISTICAS: " + me.otras_caract }],
          [{ content: "OBSERVACIÓN: " + me.observacion }],
        ],
      });

      let finalY = doc.lastAutoTable.finalY;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, finalY = finalY + 5, "IMAGEN");
      // IMAGENES
      var imgBien = "data:image/png;base64," + (me.imagen == null || me.imagen == '' ? me.imagenxdefec : me.imagen)
      var imgBien2 = "data:image/png;base64," + (me.imagen2 == null || me.imagen2 == '' ? me.imagenxdefec : me.imagen2);
      var imgBien3 = "data:image/png;base64," + (me.imagen3 == null || me.imagen3 == '' ? me.imagenxdefec : me.imagen3);
      var pageWidth = 210; // Ancho de la hoja en mm

      var imgWidth = 50; // Ancho de las imágenes
      var imgHeight = 50; // Altura de las imágenes
      var imgMargin = 5; // Margen entre las imágenes y los bordes de la página

      // Calcular la posición horizontal para las imágenes
      var startX1 = (pageWidth - imgWidth * 3 - imgMargin * 2) / 2;
      var startX2 = startX1 + imgWidth + imgMargin;
      var startX3 = startX2 + imgWidth + imgMargin;

      // Calcular la posición vertical para las imágenes
      var startY = finalY + 10;

      // Agregar las imágenes al documento con las nuevas posiciones
      doc.addImage(imgBien, "JPEG", startX1, startY, imgWidth, imgHeight);
      doc.addImage(imgBien2, "JPEG", startX2, startY, imgWidth, imgHeight);
      doc.addImage(imgBien3, "JPEG", startX3, startY, imgWidth, imgHeight);
      // Fin Detalle de Bien

      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");
    },
    /* Crear PDF bien */
  },
};
</script>
